import _ from 'lodash';
import { createReducer, on } from '@ngrx/store';
import * as DashboardActions from './dashboard.actions';

export const dashboardFeatureKey = 'dashboard';

export interface State {
  orgDonations?:null,
  campaignReport?:null,
  orgUser?:null,
  recentDonations?:null,
  upcomingReminders: any[]
}

export const initialState: State = {
  orgDonations: null,
  campaignReport: null,
  orgUser:null,
  recentDonations:null,
  upcomingReminders: []
};

export const reducer = createReducer(
  initialState,
  on(DashboardActions.loadOrgDonations, state => state),

  on(DashboardActions.loadOrgDonationsSuccess, (state, action) => {
    let orgDonations = action.data

    return {
      ...state,
      orgDonations 
    }
  }),

  on(DashboardActions.loadCampaignReport, state => state),

  on(DashboardActions.loadCampaignReportSuccess, (state, action) => {
    let campaignReport = action.data.campaigns


    return {
      ...state,
      campaignReport
    }
  }),

  on(DashboardActions.loadCampaignReport, state => state),

  on(DashboardActions.loadCampaignReportSuccess, (state, action) => {
    let campaignReport = action.data.campaigns


    return {
      ...state,
      campaignReport
    }
  }),

  on(DashboardActions.loadOrgUser, state => state),

  on(DashboardActions.loadOrgUserSuccess, (state, action) => {
    let orgUser = action.data
    let recentDonations = action.data.trimmedTransactions
    return {
      ...state,
      orgUser,
      recentDonations
    }
  }),

  on(DashboardActions.resetDashboard, (state) => {
    return {
      ...state,
      orgDonations: null,
      campaignReport: null,
      recentDonations:null
    }
  }),

  on(DashboardActions.loadUpcomingReminders, state => state),
  on(DashboardActions.loadUpcomingRemindersSuccess, (state, action) => {
    const upcomingReminders = action.data

    return {
      ...state,
      upcomingReminders
    }
  }),
  on(DashboardActions.loadUpcomingRemindersFailure, (state, action) => state),

  on(DashboardActions.cancelUpcomingReminder, state => state),
  on(DashboardActions.cancelUpcomingReminderSuccess, (state, action) => {
    const taskId = action.data
    
    const updatedUpcomingReminders = state.upcomingReminders.filter((reminder) => {
      return reminder.id !== taskId;
    });

    return {
      ...state,
      upcomingReminders: updatedUpcomingReminders,
    }
  }),
  on(DashboardActions.cancelUpcomingReminderFailure, (state, action) => state)

);

